import { EngineOffOutlineIcon } from './EngineOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 81317A61-047B-47D4-A154-CEA3C6B9F61C
 * name engine-off-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine-off-outline.svg
 * tags
 * - Automotive 
 */
export const MotorOffOutlineIcon = EngineOffOutlineIcon;
export default MotorOffOutlineIcon